import { MobileLayout } from 'components/mobile/MobileLayout/MobileLayout';
import { useModernDesktop } from 'components/Layout/ModernDesktopShell';
import { GroupedOtherBets } from 'components/OtherBets/GroupedOtherBets';
import { MatchMobile } from 'components/mobile/MatchMobile/MatchMobile';
import { useState } from 'react';
import { MatchOffer } from 'types/MatchOffer';
import { Navigate, useLocation } from 'react-router-dom';
import useAsyncEffect from 'use-async-effect';
import { getEventByid } from 'services/api/sportBetsService';
import { Loader } from 'components/Loader/Loader';
import { useBreakpoint } from 'hooks/useBreakpoint';
import { getAllBets } from 'helpers/matchHelper';
import { usePlayerLayout } from 'lib/playerLayout';
import { ModernMatchDetails } from 'components/mobile/ModernMatchDetails/ModernMatchDetails';

export const OtherBetsList = () => {
  const matchId = useLocation().pathname.split('/').pop();
  const [match, setMatch] = useState<MatchOffer | null>(null);
  const { isMobile } = useBreakpoint();
  const modernDesktop = useModernDesktop();
  const modern = usePlayerLayout() === 'modern';

  useAsyncEffect(async () => {
    setMatch(await getEventByid(Number.parseInt(matchId!)));
  }, []);

  if (!isMobile && !modernDesktop) {
    return <Navigate to="/not-found" />;
  }

  return (
    <MobileLayout pageTitle={match?.league.name ?? 'loading_label'}>
      <>
        {!match && <Loader />}
        {match && modern && <ModernMatchDetails match={match} />}
        {match && !modern && (
          <>
            <MatchMobile match={match} showFullMatchData />
            <GroupedOtherBets bets={getAllBets(match)} match={match} />
          </>
        )}
      </>
    </MobileLayout>
  );
};
